import React from 'react';

import Node from 'pages/company/components/CompanyNavigation/Categories/Node';

const Categories = ({ tree, onCategoryClick, onDocMove, onRestoreDocuments, isTrashCategory }) =>
  tree.map((item) => (
    <Node
      onDocMove={onDocMove}
      onCategoryClick={onCategoryClick}
      key={item.id}
      item={item}
      level={item.level}
      tree={item.children}
      onRestoreDocuments={onRestoreDocuments}
      isTrashCategory={isTrashCategory}
    />
  ));

export default Categories;
